import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import $ from 'jquery';

class CustomReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.handleClickInside = this.handleClickInside.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  static propTypes = {
    active: PropTypes.bool.isRequired,
    close: PropTypes.func,
    children: PropTypes.any,
    id: PropTypes.string
  };

  componentDidUpdate(prevProps, prevState) {
    const { active } = this.props;
    if (prevProps.active !== active) {
      if (active) {
        $('#app').css('overflow', 'hidden');
      } else {
        $('#app').css('overflow', '');
      }
    }
  }

  handleClickInside(e) {
    e.stopPropagation();
  }

  handleClickOutside() {
    const { close } = this.props;
    if (close) {
      close();
    }
  }

  render() {
    const { active, children, id } = this.props;
    let activeReveal = active ? 'active' : '';
    return (
      <div
        id={`custom-reveal-${id}`}
        className={`custom-reveal-${id} reveal ${activeReveal}`}
        onClick={this.handleClickOutside}
      >
        <div className={`reveal-container ${activeReveal}`} onClick={this.handleClickInside}>
          {children}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomReveal);
